import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const OkModal = (props) => {
    return (
        <Modal
            {...props}
            size={props.size || 'lg'}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>
                    {props.title}
                </Modal.Title>
                <button className='btn btn-close close' onClick={props.onHide}>
                    <i className='fa fa-close' />
                </button>
            </Modal.Header>
            <Modal.Body>
                {props.message}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Ok</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OkModal;